import React, { FunctionComponent } from 'react';
import { useEffectOnce } from 'usehooks-ts';

import { useGlobalStore } from 'store';
import { ReactComponent as SvgGrid } from 'svgs/grid.svg';
import { handleMouseEnter, handleMouseLeave } from 'utils/cursorGlobal';

import * as S from './ViewChanger.styles';

export interface ViewChangerProps {}

const defaultProps: Partial<ViewChangerProps> = {};

const ViewChanger: FunctionComponent<ViewChangerProps> = ({ ...rest }) => {
  const { isGridView, setIsGridView } = useGlobalStore();

  useEffectOnce(() => {
    return () => setIsGridView(false);
  });

  return (
    <S.Wrapper
      onClick={() => setIsGridView(!isGridView)}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      {...rest}
    >
      <S.SvgContainer>
        <SvgGrid />
      </S.SvgContainer>
    </S.Wrapper>
  );
};

ViewChanger.defaultProps = defaultProps;

export default ViewChanger;
